import api from './api';

export interface Court {
    id: string;
    merchant_id: string;
    name: string;
    location: string;
    status: string;
    indoor: boolean;
    created_at: string;
    updated_at: string;
    // Add other court properties as needed
}

export const courtsService = {
  // Fetch courts by merchant ID
    async fetchCourtsByMerchant(merchantId: string): Promise<Court[]> {
        const response = await api.get<Court[]>(`/courts/merchant/${merchantId}`);
        return response.data;
    },

    async fetchCourtById(courtID:string): Promise<Court> {
        const response = await api.get<Court>(`/courts/${courtID}`);
        return response.data;
    }
}